export default {
    driver_performance_riskTab_caseUpdatedCorrectly: "Caso actualizado correctamente",
    driver_performance_riskTab_errorOccurredWhileUpdatingTheCase: "Se produjo un error al actualizar el caso.",
    driver_performance_riskTab_commentSavedSuccessfully: "Comentario guardado con éxito",
    driver_performance_riskTab_errorOccurredWhileCreatingTheComments: "Se produjo un error al crear los comentarios",
    driver_performance_riskTab_noEventsFound: "No se encontraron eventos",
    driver_performance_riskTab_eventMarkedAsRead: "Evento marcado como leído",
    driver_performance_riskTab_noVideoDataAvailableForThisEvent: "No hay datos de video disponibles para este evento",
    driver_performance_riskTab_omit: "Omitir",
    driver_performance_riskTab_eventStatus: "Estado del Evento",
    driver_performance_riskTab_driverDisputed: "Conductor en Disputa",
    driver_performance_riskTab_clickEvent: "Haga clic en un evento de la lista para ver los detalles",
    driver_performance_riskTab_selectACategoryToViewEvents: "Seleccione una categoría para ver eventos",
    driver_performance_riskTab_comments: "Comentarios",
    driver_performance_riskTab_noCommentsAvailableForThisEvent: "No hay comentarios disponibles para este evento",
    driver_performance_riskTab_selectAnEventToViewComments: "Seleccione un evento para ver comentarios",
    driver_performance_riskTab_addComment: "Agregar Comentario",
}
